import React from 'react';
import { Box, Typography } from '@mui/material';
import CertificateHeader from './CertificateHeader';


/**
 * Form 15A - Caste Certificate
 * Certificate to be given by Principal of the School/College
 * Matches the actual printed form from Vidya Pratishthan's school
 */
export const Form15ATemplate = ({ data }) => {
    const { student, details, academicYear } = data;

    return (
        <Box sx={{
            fontFamily: '"Times New Roman", Georgia, serif',
            fontSize: '13px',
            lineHeight: 1.6,
            color: '#000',
            backgroundColor: '#fff',
            p: '15mm',
            width: '210mm',
            minHeight: '297mm',
            boxSizing: 'border-box',
            '@media print': {
                width: '210mm',
                margin: 0,
                padding: '15mm',
            }
        }}>
            {/* School Header */}
            <CertificateHeader isLeavingCertificate={false} details={details} />


            {/* Sr. No. */}
            <Box sx={{ textAlign: 'right', mb: 1 }}>
                <Typography sx={{ fontSize: 12, fontFamily: 'inherit' }}>
                    Sr. No.:__________
                </Typography>
            </Box>

            {/* Form Title */}
            <Typography sx={{
                textAlign: 'center', fontSize: 18, fontWeight: 'bold',
                textDecoration: 'underline', mb: 2, fontFamily: 'inherit'
            }}>
                Form 15 A
            </Typography>

            {/* Sub Title */}
            <Typography sx={{
                textAlign: 'center', fontSize: 14, fontWeight: 'bold',
                mb: 3, fontFamily: 'inherit'
            }}>
                Certificate to be given by Principal of the School/College
            </Typography>

            {/* Certificate Body */}
            <Box sx={{ px: 2, mb: 4 }}>
                <Typography sx={{ fontSize: 14, textAlign: 'justify', lineHeight: 2, fontFamily: 'inherit' }}>
                    &nbsp;&nbsp;&nbsp;&nbsp;This is to certify that {student?.gender === 'Female' ? 'Kumari' : 'Kumar'}{' '}
                    <strong style={{ textDecoration: 'underline' }}>{student?.name || '________________'}</strong>{' '}
                    is student of this School/college in Year{' '}
                    <strong style={{ textDecoration: 'underline' }}>{academicYear || '2025-2026'}</strong>{' '}
                    and {student?.gender === 'Female' ? 'she' : 'he'} is studying in{' '}
                    <strong style={{ textDecoration: 'underline' }}>
                        {details?.currentClass || '____'} {details?.currentDivision ? details.currentDivision : ''}
                    </strong>{' '}
                    faculty. {student?.gender === 'Female' ? 'Her' : 'His'} name and other information is as per
                    mentioned at number{' '}
                    <strong style={{ textDecoration: 'underline' }}>{student?.admissionNumber || '____'}</strong>{' '}
                    in General Register. And the Caste stated as per our General Register is{' '}
                    <strong style={{ textDecoration: 'underline' }}>{details?.caste || '________________'}</strong>.
                </Typography>
            </Box>

            {/* Signature Section */}
            <Box sx={{ textAlign: 'right', mt: 6, pr: 4 }}>
                <Typography sx={{ fontSize: 13, fontFamily: 'inherit' }}>
                    Seal and Signature of Principal/Head Master
                </Typography>
            </Box>

            {/* Important Instructions */}
            <Box sx={{
                mt: 8, pt: 2, borderTop: '1px solid #000',
                fontFamily: 'inherit'
            }}>
                <Typography sx={{ fontSize: 13, fontWeight: 'bold', mb: 1, textDecoration: 'underline' }}>
                    Important Instruction :-
                </Typography>
                <Typography sx={{ fontSize: 11, mb: 0.5, fontFamily: 'inherit' }}>
                    a) If Claim for Scheduled Caste, Caste evidences should be prior to 10th August 1950.
                </Typography>
                <Typography sx={{ fontSize: 11, mb: 0.5, fontFamily: 'inherit' }}>
                    b) If Claim for De-Notified Tribes (Vimukta Jatis), Nomadic Tribes Caste evidences should be prior to 21 November 1961.
                </Typography>
                <Typography sx={{ fontSize: 11, mb: 0.5, fontFamily: 'inherit' }}>
                    c) If Claim for Other Backward Class and Special Backward Category, Caste evidences should be prior to 13 October 1967.
                </Typography>
                <Typography sx={{ fontSize: 11, mb: 0.5, fontFamily: 'inherit' }}>
                    d) In addition, evidence of residents of above mentioned prior is essential for applicant who has migrated in Maharashtra from other State.
                </Typography>
                <Typography sx={{ fontSize: 11, mb: 0.5, fontFamily: 'inherit' }}>
                    e) Migrants from other State to Maharashtra after above mention period whose Caste Certificate is in "Migrants" format should not apply to committee.
                </Typography>
            </Box>
        </Box>
    );
};

export default Form15ATemplate;
